<template>
  <div class="cashdetail-box">
    <div class="wallet-box-item">
      <div class="profile-title">
        <div>My Cash</div>
      </div>
      <div>
        <div class="cash-item">
          <div class="cash-item-name">
            Paypal Account:

            <span class="paypal-update" v-if="payNO" @click="toAccount"
              >To Update</span
            >
            <span class="paypal-update" v-if="!payNO" @click="toAccount"
              >To Add</span
            >
          </div>
          <div class="paypal-account" v-if="payNO">{{ payNO }}</div>
          <!-- <div class="cash-item-value">643339036@qq.com</div> -->
        </div>

        <div class="cash-item">
          <div class="cash-item-value">
            <el-form :model="moneyForm" ref="moneyForm" :rules="moneyFormRules">
              <el-form-item prop="money">
                <div class="cash-money">
                  <div class="cash-money-li">
                    <span v-if="ketianxianSum >= 0" class="ketianxiansum"
                      >(&nbsp;Cashable amount:&nbsp;C$&nbsp;{{
                        ketianxianSum
                      }}&nbsp;)</span
                    >
                  </div>
                  <div class="cash-money-li">
                    <span class="input_t">C$</span>
                    <el-input
                      v-model="moneyForm.money"
                      @input="handleInput($event, 'money')"
                    ></el-input>
                  </div>
                </div>
                <div class="cash-bt">
                  <el-button class="cash-out-button" @click="confirmCash"
                    >Confirm</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="cash-fee">Handling fee:&nbsp;C${{ tixianFee }}</div>
        <div class="cash-fee">
          Service fee:&nbsp;C${{ Math.round(tixianFees.extraFee || 0) / 100 }}
        </div>
      </div>
    </div>

    <div class="account-box">
      <!-- <div class="profile-title">Cash Details</div> -->
      <el-table :data="accountRecordlist" class="accout-table">
        <!-- <el-table-column label="No" type="index"></el-table-column> -->
        <el-table-column label="Cash Details">
          <template slot-scope="scope">
            <div class="account-item">
              <div class="account-money">
                {{ scope.row.money | formatMoneyNumber }}
              </div>
              <div>
                <el-tag type="info" v-if="scope.row.status === 0" size="small"
                  >pending</el-tag
                >
                <el-tag type="error" v-if="scope.row.status === 1" size="small"
                  >rejected</el-tag
                >
                <el-tag
                  type="success"
                  v-if="scope.row.status === 2"
                  size="small"
                  >transferred</el-tag
                >
                <el-tag type="info" v-if="scope.row.status === 3" size="small"
                  >failed</el-tag
                >
                <el-tag type="info" v-if="scope.row.status === 4" size="small"
                  >in progress</el-tag
                >
              </div>
            </div>
            <div class="account-item">
              <div class="payno">payNo:&nbsp;&nbsp;{{ scope.row.payNo }}</div>
            </div>
            <div class="account-item">
              <div>{{ scope.row.create_time | formatTime }}</div>
            </div>
            <div class="account-text" v-if="scope.row.failed_reason">
              Failed reason:&nbsp;&nbsp;{{ scope.row.failed_reason }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Money" prop="money">
          <template slot-scope="scope">
            {{ scope.row.money | formatMoneyNumber }}
          </template>
        </el-table-column>
        <el-table-column label="Paypal Account" prop="payNo"></el-table-column>
        <el-table-column label="Status">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.status === 0" size="small"
              >待处理</el-tag
            >
            <el-tag type="error" v-if="scope.row.status === 1" size="small"
              >已拒绝</el-tag
            >
            <el-tag type="success" v-if="scope.row.status === 2" size="small"
              >已转账</el-tag
            >
            <el-tag type="info" v-if="scope.row.status === 3" size="small"
              >转账失败</el-tag
            >
            <el-tag type="info" v-if="scope.row.status === 4" size="small"
              >处理中</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="Apply Time">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatTime }}
          </template>
        </el-table-column>
        <el-table-column label="Failed Reason">
          <template slot-scope="scope">
            <span class="reason">{{ scope.row.failed_reason }}</span>
          </template>
        </el-table-column> -->
      </el-table>
      <KtPag
        style="text-align: right"
        :pageCount="accountRecordForm.count"
        :currentPage="accountRecordForm.page"
        :limit="accountRecordForm.limit"
        @onChange="onPageChange"
      ></KtPag>
    </div>
  </div>
</template>

<script>
import { format } from "@/utils/comm";
import { mapState, mapGetters } from "vuex";
import ValidateButton from "@/views/Mobile/Component/ValidateButton";
import { Md5ChangePass, scopeDomain, secreKey } from "@/utils/comm";
import KtPag from "@/views/Comm/KtPag";
import moment from "moment";
export default {
  components: {
    ValidateButton,
    KtPag,
  },
  filters: {
    formatTime(val) {
      if (val && moment(val).isValid())
        return moment(val).format("DD/MM/YYYY/ HH:mm:ss");
      else return "-";
    },
    formatMoneyNumber(value) {
      if (typeof value === "number" && !isNaN(value)) {
        return (Number(value) / 100).toFixed(2);
      } else {
        return "-";
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.app.userInfo,
      ketixian: (state) => state.app.userInfo.ketixian,
    }),
    tixianFee() {
      if (this.moneyForm.money && !isNaN(Number(this.moneyForm.money))) {
        return (
          Math.round(
            (Number(this.moneyForm.money) +
              Number(this.tixianFees.extraFee) / 100) *
              Number(this.tixianFees.tixianFee) *
              100
          ) / 100
        );
      } else {
        return 0;
      }
    },
  },
  data() {
    let validateMoney = (rule, value, callback) => {
      if (!value || isNaN(Number(value))) {
        this.moneyForm.money = "";
        callback(
          new Error(
            "Please enter the cash-out amount, keep two decimal places."
          )
        );
      } else {
        // this.moneyForm.money = parseFloat(this.moneyForm.money || 0).toFixed(2);
        let totalmoney =
          Math.round(
            (Number(value) +
              (Number(value) + Number(this.tixianFees.extraFee) / 100) *
                Number(this.tixianFees.tixianFee)) *
              100
          ) / 100;
        if (parseFloat(this.ketixian) < parseFloat(totalmoney)) {
          callback(
            new Error("Amount entered exceeds the maximum cashable amount.")
          );
        } else {
          callback();
        }
      }
    };
    return {
      queryStr: "",
      accountRecordlist: [],
      format: format,
      type_map: {
        1: "settlement",
        2: "cash-out",
        3: "recharge",
        4: "pay payment",
        5: "partial refundable",
        6: "refund",
        7: "penalty",
      },
      accountRecordForm: {
        page: 1,
        limit: 10,
        count: 0,
      },
      moneyFormRules: {
        money: [
          {
            required: true,
            validator: validateMoney,
            trigger: "change",
          },
        ],
      },
      moneyForm: {},
      payNO: "",
      tixianFees: {},
      ketianxianSum: 0,
    };
  },
  created() {
    this.$store.dispatch("REFRESH_USER_INFO");
  },
  mounted() {
    this.getCashApplyList();
    this.getPaypal();
    this.getTixianFee();
  },
  methods: {
    handleInput(value, name) {
      // 通过正则过滤小数点后两位
      // e.target.value = e.target.value.match(/^\d*(\.?\d{0,1})/g)[0] || null;
      this.moneyForm[name] =
        ("" + value) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
    },
    toAccount() {
      if (this.userInfo.usertype === 1) {
        this.$router.push("/groupInfo/account");
      } else {
        this.$router.push("/myinfo/profile");
      }
    },
    getPaypal() {
      this.$api.comApi.getBankList().then((res) => {
        if (res.status === "0") {
          if (res.data.rows.length > 0) {
            this.payNO = res.data.rows[0].payNO || "";
          }
        }
      });
    },
    getTixianFee() {
      this.$api.accountApi.getTixianFee().then((res) => {
        if (res.status === "0") {
          this.tixianFees = res.data;
          if (typeof this.ketixian === "number" && !isNaN(this.ketixian)) {
            this.ketianxianSum =
              Math.round(
                Number(this.ketixian || 0) /
                  (1 + Number(this.tixianFees.tixianFee || 0)) -
                  Number(this.tixianFees.extraFee || 0)
              ) / 100;
          } else {
            this.ketianxianSum = 0;
          }
          // if (res.data.rows.length > 0) {
          //   this.payNO = res.data.rows[0].payNO || "";
          // }
        }
      });
    },
    toMyCoupons() {
      this.$router.push("/myinfo/coupons");
    },
    getCashApplyList() {
      let params = {};
      params["page"] = this.accountRecordForm.page;
      params["limit"] = this.accountRecordForm.limit;
      this.$api.accountApi.getCashApplyList(params).then((res) => {
        if (res.status === "0") {
          this.accountRecordlist = res.data.rows;
          this.accountRecordForm.count = res.data.count;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onPageChange({ page, limit }) {
      this.accountRecordForm.page = page;
      this.accountRecordForm.limit = limit;
      this.getCashApplyList();
    },
    confirmCash() {
      if (!this.payNO) {
        this.$message({
          type: "warning",
          message: "Please select paypal account !",
        });
        return;
      }
      this.$refs["moneyForm"].validate(async (valid) => {
        if (!valid) {
          return;
        }
        this.$confirm(
          "Are you sure you want to withdraw to paypal account?",
          "Prompt",
          {
            type: "warning",
          }
        )
          .then(async () => {
            // let totalmoney = Math.round(
            //   (Number(money) +
            //     (Number(this.moneyForm.money) +
            //       Number(this.tixianFees.extraFee)) *
            //       Number(this.tixianFees.tixianFee)) *
            //     100
            // );
            // console.log('totalmoney',totalmoney)
            let params = {
              money: Math.round(Number(this.moneyForm.money) * 100),
              csign: Md5ChangePass(
                `key=9MUtRANzs4A37Ff8vn38ZIRI7kCmhBlq&money=${Math.round(
                  Number(this.moneyForm.money) * 100
                )}&key=9MUtRANzs4A37Ff8vn38ZIRI7kCmhBlq`
              ),
            };
            const { status, message } = await this.$api.accountApi.cashApply(
              params
            );
            this.$message({
              message: message,
              type: status === "0" ? "success" : "error",
            });
            if (status === "0") {
              this.moneyForm.money = "";
              this.getCashApplyList();
            }
          })
          .catch((err) => {
            // console.log(err);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.cashdetail-box {
  .wallet-box-item {
    box-sizing: border-box;
    background-color: #fff;
    width: 100%;
    padding: 16px;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    margin-bottom: 24px;
    .profile-title {
      height: 25px;
      font-size: 18px;
      font-weight: 600;
      color: #181d2c;
      line-height: 25px;
      display: flex;
      justify-content: space-between;
      .my-coupons {
        cursor: pointer;
        color: #f48c06;
        font-size: 14px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .reason {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .cash-item {
      padding: 10px 0;
      .cash-item-name {
        height: 30px;
        font-size: 14px;

        color: #181d2c;
        line-height: 30px;
      }
      .paypal-account {
        font-weight: 600;
        color: #f48c06;
        font-size: 14px;
        line-height: 20px;
        word-break: break-all;
      }
      .paypal-update {
        margin-left: 10px;
        font-size: 14px;
        cursor: pointer;
        font-weight: 500;
        text-decoration: underline;
        &:hover {
          opacity: 0.54;
        }
      }
      .el-form {
        width: 100%;
      }
      .cash-item-value {
        display: flex;
        flex-direction: row;
        // width: 50%;
        // margin-top: 8px;
        // height: 50px;
        font-size: 20px;
        font-weight: 600;
        color: #f48c06;
        // line-height: 50px;
        align-items: center;
        /deep/ .el-form-item__content {
          display: flex;
          // align-items: center;
          /deep/ .el-input {
            margin: 0 10px;
          }
          /deep/ .el-input__inner {
            font-size: 18px;
            margin: 0 10px;
          }
          .cash-money {
            flex: 2;
            .cash-money-li {
              display: flex;
              // .ketianxiansum {
              //   padding-left: 15px;
              // }
              .input_t {
                width: 20px;
                margin-right: 5px;
              }
            }
          }
          .cash-bt {
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
          }
        }
      }
      .cash-out-button {
        background: #f48c06;
        border: none;
        color: #fff;
        font-size: 14px;
        &:hover {
          opacity: 0.54;
        }
      }
    }
    .cash-fee {
      color: #606266;
      padding: 5px 0;
      font-size: 14px;
    }
  }
  .account-box {
    background: #fff;
    border-radius: 8px;
    padding-bottom: 12px;
    box-sizing: border-box;
    .accout-table {
      border-radius: 8px;
    }
    .account-item {
      min-height: 35px;
      line-height: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .account-type {
        font-size: 16px;
        font-weight: 600;
        color: #181d2c;
      }
      .account-money {
        font-size: 16px;
        font-weight: 600;
        color: #f48c06;
      }
      .account-cashable {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .account-text {
      line-height: 22px;
    }
  }
}
</style>